import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "../CSS/Home.css";

import TitleImage from "../assets/TitleImage.jpg";
import TurGhidat from "../assets/Tur-LivTuVisit.mp4";
import ExperienteAutentice from "../assets/ExperienteAutenticeLocale.jpg";
import TreasureHunt from "../assets/TreasureHunt.jpg";
import TururiPietonale from "../assets/tururipietonale.jpg";
import CNIMB from "../assets/CNI'MATEI-BASARAB'.svg";
import CNMB from "../assets/CNMB.svg";
import BNI from "../assets/BNI-Romania.svg";
import AlbastrusiOrigin from "../assets/albastrusiorigini.svg";
import Alsystravel from "../assets/alsystravel.svg";
import OMIS from "../assets/ASOCIATIA OMIS.svg";
import AsociatiaMamicilor from "../assets/asociatiamamici.png";
import FCVL from "../assets/logo_FCVL.png";
import MuzeulSatului from "../assets/MUZEUL SATULUI VALCEAN.svg";
import Xplorate from "../assets/XPLORATE.svg";
import MeilorTravel from "../assets/melior travell.svg";
import CentrulDeInformareTuristica from "../assets/CENTRUL DE INFORMARE TURISTICA.svg";
import Carousel1 from "../assets/livtuvisit your city (25).jpg";
import Carousel2 from "../assets/livtuvisit your city (33).jpg";
import Carousel3 from "../assets/livtuvisit your city (42).jpg";
import Carousel4 from "../assets/livtuvisit your city (43).jpg";

function Home() {
  const navigate = useNavigate();
  const formRef = useRef(null);
  const [statusMessage, setStatusMessage] = useState("");
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  // Scroll to top on navigate
  const navigateAndScrollTop = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  // Handle reCAPTCHA
  const onCaptchaChange = (value) => {
    setIsCaptchaVerified(!!value);
  };

  // Send email using EmailJS
  const sendEmail = (e) => {
    e.preventDefault();

    if (!isCaptchaVerified) {
      setStatusMessage("Please complete the CAPTCHA to proceed.");
      return;
    }

    emailjs
      .sendForm(
        "service_xd4zuwd", // Replace with your EmailJS service ID
        "template_2jdkpyk", // Replace with your EmailJS template ID
        formRef.current,
        "38BZt8PKdissr2Wbo" // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log("Email sent:", result.text);
          setStatusMessage("Your message has been sent!");
          formRef.current.reset();
          setIsCaptchaVerified(false);
        },
        (error) => {
          console.error("Error sending email:", error.text);
          setStatusMessage("Oops, something went wrong. Please try again.");
        }
      );
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);




  // Inject Elfsight Google Reviews script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 1 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  console.log("isMobile:", isMobile, "width:", window.innerWidth);


  return (
    <div style={styles.container}>
      {/* Hero Section */}
      <div style={styles.heroSection}>
        <video autoPlay muted loop playsInline style={styles.heroImage}>
          <source src={TurGhidat} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Content Section */}
      <div style={styles.carouselFormContainer}>
        <div style={styles.carouselContainer}>
          <Carousel responsive={responsive} infinite autoPlay>
            <img src={Carousel1} style={styles.carouselImage} alt="1" />
            <img src={Carousel2} style={styles.carouselImage} alt="2" />
            <img src={Carousel3} style={styles.carouselImage} alt="3" />
            <img src={Carousel4} style={styles.carouselImage} alt="4" />
          </Carousel>
          <h2 style={styles.contentHeading}>Liv Tu Visit Your City</h2>
          <p style={styles.contentParagraph}>
            Livia & Tudor, deci Liv Tu Visit Your City, isi propune sa va arate în moduri noi şi interactive locurile pe care CREDETI că le cunoaştiţi foarte bine sau pe lângă care treceţi zilnic.
          </p>
          <div style={styles.buttonGroup}>
            <button
              style={styles.linkButton}
              onClick={() => navigateAndScrollTop("/trips")}
            >
              Hai să ne plimbăm împreună
            </button>
          </div>
        </div>

        <div style={styles.formContainer}>
          <h2 style={styles.miniContactHeading}>Ştii deja ce vrei?</h2>
          <form ref={formRef} style={styles.miniContactForm} onSubmit={sendEmail}>
            <div style={styles.miniFormRow}>
              <input type="date" name="booking_date" style={styles.miniInput} required />
              <input type="number" name="numar_persoane" placeholder="Număr de persoane" style={styles.miniInput} required />
              <input type="email" name="from_email" placeholder="Adresa de email" style={styles.miniInput} required />
              <input type="text" name="from_name" placeholder="Numele tău" style={styles.miniInput} required />
              <select name="trip_type" style={styles.miniInput} required>
                <option value="">Selectează tipul de tur</option>
                <option value="Tur Pietonal">Tur Pietonal</option>
                <option value="Tur Regional">Tur Regional</option>
                <option value="Experiență Interactivă">Experiență Interactivă</option>
              </select>
              <input type="hidden" name="to_name" value="Liv Tu Visit" />
              <input type="hidden" name="subject" value="Mini Contact Booking Request" />
            </div>
            <textarea name="message" placeholder="Mesajul tău..." style={styles.miniTextarea} required></textarea>
            <div style={styles.recaptcha}>
              <ReCAPTCHA sitekey="6LdIJdEqAAAAAIjUCxrJSAAz6SUsSJ2z24ySvMXd" onChange={onCaptchaChange} />
            </div>
            <button type="submit" style={styles.miniButton} disabled={!isCaptchaVerified}>
              Contactează-ne
            </button>
          </form>
          {statusMessage && <p style={styles.statusMessage}>{statusMessage}</p>}
        </div>
      </div>

      {/* Widgets Section */}
      <div style={styles.widgetsSection}>
        <div
          style={styles.widgetCard}
          onClick={() => navigateAndScrollTop("/trips/tururi-pietonale")}
        >
          <img
            src={TururiPietonale}
            alt="Tururi pietonale"
            style={styles.widgetImage}
          />
          <h2 style={styles.widgetTitle}>Tururi pietonale</h2>
        </div>
        <div
          style={styles.widgetCard}
          onClick={() => navigateAndScrollTop("/trips/tururi-regionale")}
        >
          <img
            src={ExperienteAutentice}
            alt="Experiențe autentice"
            style={styles.widgetImage}
          />
          <h2 style={styles.widgetTitle}>Experiențe autentice</h2>
        </div>
        <div
          style={styles.widgetCard}
          onClick={() => navigateAndScrollTop("/trips/experiente-interactive")}
        >
          <img
            src={TreasureHunt}
            alt="Experiență interactivă"
            style={styles.widgetImage}
          />
          <h2 style={styles.widgetTitle}>Experiență interactivă</h2>
        </div>
      </div>

      {/* Google Reviews Widget */}
      <div style={styles.reviewSection}>
        <div
          className="elfsight-app-acdda116-aeeb-46b7-8dc7-5d5479e76abf"
          data-elfsight-app-lazy
        ></div>
      </div>

      {/* Partners Section */}
      <div style={styles.partnersSection}>
        <h2 style={styles.partnersHeading}>Partenerii noștri</h2>
        <div style={styles.partnersLogos}>
          <a href="https://cnimateibasarab.ro/cnimb/" target="_blank" rel="noopener noreferrer">
            <img src={CNIMB} alt=" Colegiu Nationa de Informatica 'Matei Basarab' " style={styles.partnerLogo} />
          </a>
          <a href="https://cnmirceavl.ro" target="_blank" rel="noopener noreferrer">
            <img src={CNMB} alt=" Colegiul National 'Mircea cel Batran'" style={styles.partnerLogo} />
          </a>
          <a href="https://bni-romania.com/ro-RO/index" target="_blank" rel="noopener noreferrer">
            <img src={BNI} alt=" BNI Romania'" style={styles.partnerLogo} />
          </a>
          <a href="https://albastrusiorigini.ro" target="_blank" rel="noopener noreferrer">
            <img src={AlbastrusiOrigin} alt=" Albastru si Origin'" style={styles.partnerLogo} />
          </a>
          <a href="https://www.alsystravel.ro" target="_blank" rel="noopener noreferrer">
            <img src={Alsystravel} alt=" Alsys Travel'" style={styles.partnerLogo} />
          </a>
          <a href="https://omis.ro" target="_blank" rel="noopener noreferrer">
            <img src={OMIS} alt=" Asociatia Omis'" style={styles.partnerLogo} />
          </a>
          <a href="https://www.facebook.com/mamicidinvalcea/?locale=ro_RO" target="_blank" rel="noopener noreferrer">
            <img src={AsociatiaMamicilor} alt=" Asociatia Mamicilor din Valcea'" style={styles.partnerLogo} />
          </a>
          <a href="https://fcvl.ro" target="_blank" rel="noopener noreferrer">
            <img src={FCVL} alt=" Fundatia Comunitara Valcea'" style={styles.partnerLogo} />
          </a>
          <a href="https://xplorate.ro" target="_blank" rel="noopener noreferrer">
            <img src={Xplorate} alt=" Xplorate" style={styles.partnerLogo} />
          </a>
          <a href="https://www.facebook.com/p/Muzeul-Satului-Vâlcean-100071813000580/?locale=ro_RO" target="_blank" rel="noopener noreferrer">
            <img src={MuzeulSatului} alt=" Muzeul Satului Valcean" style={styles.partnerLogo} />
          </a>
          <a href="https://www.facebook.com/meliortravel.ro/?locale=ro_RO" target="_blank" rel="noopener noreferrer">
            <img src={MeilorTravel} alt=" Meilor Travel" style={styles.partnerLogo} />
          </a>
          <a href="https://www.facebook.com/cniptvalcea/?locale=ro_RO" target="_blank" rel="noopener noreferrer">
            <img src={CentrulDeInformareTuristica} alt=" Centrul de Informare Turistica" style={styles.partnerLogo} />
          </a>
          {/* Adaugă mai mulți parteneri după nevoie */}
        </div>
      </div>

    </div>
  );
}

const styles = {
  container: {
    backgroundColor: "#F4F9F9",
    fontFamily: "'Georgia', serif",
    margin: 0,
    padding: 0,
  },
  heroSection: {
    position: "relative",
    width: "100%",
    height: "60vh",
    overflow: "hidden",
  },
  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  carouselFormContainer: {
  display: "flex",
  flexDirection:  "row",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: "2rem",
  padding: "2rem",
  maxWidth: "1200px",
  margin: "0 auto",
  },
  carouselContainer: {
    flex: 1,
    minWidth: "300px",
    maxWidth: "600px",
  },
  carouselImage: {
    width: "100%",
    height: "auto",
    borderRadius: "8px",
    objectFit: "cover",
    transition: "transform 0.3s ease",
  },
  contentHeading: {
    fontSize: "2rem",
    marginTop: "1rem",
    color: "#2C3E50",
  },
  contentParagraph: {
    fontSize: "1.1rem",
    lineHeight: 1.8,
    color: "#4A4A4A",
  },
  formContainer: {
    flex: 1,
    minWidth: "300px",
    maxWidth: "500px",
    backgroundColor: "#EFEFEF",
    padding: "1.5rem",
    borderRadius: "8px",
  },
  miniContactHeading: {
    fontSize: "1.5rem",
    marginBottom: "1rem",
    color: "#2C3E50",
    textAlign: "center",
  },
  miniContactForm: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  miniFormRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "1rem",
    justifyContent: "center",
  },
  miniInput: {
    padding: "0.75rem",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    minWidth: "200px",
    width: "100%",
  },
  miniTextarea: {
    width: "100%",
    padding: "0.75rem",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    minHeight: "80px",
  },
  recaptcha: {
    display: "flex",
    justifyContent: "center",
  },
  miniButton: {
    padding: "0.8rem 1.5rem",
    backgroundColor: "#C39A79",
    color: "#FFFFFF",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "bold",
  },
  statusMessage: {
    marginTop: "1rem",
    fontWeight: "bold",
    color: "#2C3E50",
    textAlign: "center",
  },
  container: {
    backgroundColor: "#F4F9F9",
    fontFamily: "'Georgia', serif",
    margin: "0",
    padding: "0",
  },
  heroSection: {
    position: "relative",
    width: "100%",
    height: "60vh",
    overflow: "hidden",
  },
  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  contentSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "2rem",
    gap: "2rem",
    flexWrap: "wrap",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  textContent: {
    flex: "1",
    maxWidth: "500px",
  },
  contentHeading: {
    fontSize: "2rem",
    marginBottom: "1rem",
    color: "#2C3E50",
  },
  contentParagraph: {
    fontSize: "1.1rem",
    lineHeight: "1.8",
    marginBottom: "1.5rem",
    color: "#4A4A4A",
  },
  buttonGroup: {
    display: "flex",
    gap: "1rem",
  },
  linkButton: {
    padding: "0.8rem 1.5rem",
    backgroundColor: "transparent",
    border: "2px solid #C39A79",
    color: "#C39A79",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "bold",
    transition: "color 0.3s, border-color 0.3s",
  },
  imageContent: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "500px",
  },
  contentImage: {
    width: "100%",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  },
  miniContactSection: {
    backgroundColor: "#EFEFEF",
    padding: "2rem",
    textAlign: "center",
    margin: "2rem auto",
    borderRadius: "8px",
    maxWidth: "800px",
  },
  miniContactHeading: {
    fontSize: "2rem",
    marginBottom: "1rem",
    color: "#2C3E50",
  },
  miniContactForm: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",
  },
  miniFormRow: {
    display: "flex",
    justifyContent: "center",
    gap: "1rem",
    flexWrap: "wrap",
  },
  miniInput: {
    padding: "0.75rem",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    minWidth: "200px",
    width: "100%",
  },
  miniTextarea: {
    width: "80%",
    padding: "0.75rem",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    minHeight: "80px",
    resize: "vertical",
  },
  recaptcha: {
    margin: "1rem 0",
    display: "flex",
    justifyContent: "center",
  },
  miniButton: {
    padding: "0.8rem 1.5rem",
    backgroundColor: "#C39A79",
    color: "#FFFFFF",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "bold",
    transition: "background-color 0.3s",
  },
  statusMessage: {
    marginTop: "1rem",
    fontWeight: "bold",
    color: "#2C3E50",
  },
  reviewSection: {
    margin: "2rem auto",
    maxWidth: "auto",
    textAlign: "center",
  },
  widgetsSection: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "2rem",
    padding: "2rem",
    backgroundColor: "#EFEFEF",
  },
  widgetCard: {
    flex: "1 1 300px",
    textAlign: "center",
    cursor: "pointer",
    padding: "1.5rem",
    backgroundColor: "#FFF",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  },
  widgetImage: {
    width: "100%",
    height: "200px",
    objectFit: "cover",
    borderRadius: "8px",
  },
  widgetTitle: {
    fontSize: "1.5rem",
    margin: "1rem 0 0.5rem 0",
    color: "#2C3E50",
  },

  partnersSection: {
  padding: "3rem 2rem",
  backgroundColor: "#ffffff",
  textAlign: "center",
  },

partnersHeading: {
  fontSize: "2rem",
  marginBottom: "2rem",
  color: "#2C3E50",
  },

partnersLogos: {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "2rem",
  },

partnerLogo: {
  maxWidth: "150px",
  height: "auto",
  transition: "transform 0.3s",
  cursor: "pointer",
  },
};

export default Home;